import { host } from "config/api.config"
import { SantanderRestaurantDashboardDataDTO } from "model/dashboard/dashboardRestaurantSantanderData.model"
import { ListDashboardOccupationAndReservationDataDTO } from "model/dashboard/listDashboardReservationAndOccupationData.model"
import { ListDashboardReservationAndOccupationFilter } from "model/dashboard/listDashboardReservationAndOccupationFilter.model"
import { ListSantanderDashboardRooms } from "model/dashboard/listSantanderDashboardRooms.model"
import { ListSantanderDashboardRoomsFilterDTO } from "model/dashboard/listSantanderDashboardRoomsFilter.model"
import { RoomReservationDashboardData } from "model/dashboard/roomReservationDashboardData.model"
import { RoomDashboardDataDTO } from "model/dashboard/santander/roomDashboardData"
import { DashboardDataType } from "model/dashboardData.model"
import { DashboardFilter } from "model/dashboardFilters.model"
import { IndicatorRecordType } from "model/indicatorRecord.model"
import { useHTTPClient } from "services/httpClient.service"

const dashboardUrl = `${host}/dashboard`

export function useGetDashboardDataApi(){
    const {data, loading, error, get} = useHTTPClient<DashboardDataType>(`${dashboardUrl}`)
    async function getApi(filter: DashboardFilter){
        const jsonString = JSON.stringify(filter);
        const queryString = encodeURIComponent(jsonString);
        const _filter = `?filter=${queryString}`
        return await get({_url: `${dashboardUrl}${_filter}`})
    }
    return {
        data,
        loading,
        error,
        get: getApi
    }
}

export function useGetRoomReservationDashboardDataApi(roomId: string){
    const {data, loading, error, get} = useHTTPClient<RoomReservationDashboardData>(`${dashboardUrl}/room-reservation`)
    
    function getApi(){
        return get({params: {roomId}})
    }

    return {
        data,
        loading,
        error,
        get: getApi
    }
}

export function useListSantanderDashboardRoomsApi(){
    const {data, loading, error, get} = useHTTPClient<ListSantanderDashboardRooms[]>(`${dashboardUrl}/santander/rooms`)
    
    async function getApi(filter: ListSantanderDashboardRoomsFilterDTO){
        return await get({params: filter})
    }

    return {
        data,
        loading,
        error,
        get: getApi
    }
}

export function useGetRoomOccupationCountApi(){
    const {data, loading, error, get} = useHTTPClient<IndicatorRecordType>(`${dashboardUrl}/room-occupation-count`)

    async function getApi(roomId: string){
        return await get({params: {roomId}})
    }

    return {
        data,
        loading,
        error,
        get: getApi
    }
}

export function useGetRoomReservationAndOccupationDashboardDataApi(){
    const {data, loading, error, get} = useHTTPClient<ListDashboardOccupationAndReservationDataDTO[]>(`${dashboardUrl}/santander/room-reservation-and-occupation`)
    
    function getApi(filter: ListDashboardReservationAndOccupationFilter){
        return get({params: {...filter}})
    }

    return {
        data,
        loading,
        error,
        get: getApi
    }
}

export function useGetSantanderRestaurantsDashboardDataApi(){
    const {data, loading, error, get} = useHTTPClient<SantanderRestaurantDashboardDataDTO>(`${dashboardUrl}/santander/restaurant`)

    return {
        data,
        loading,
        error,
        get
    }
}

export function useGetSantanderRoomDashboardDataApi(){
    const {data, loading, error, get} = useHTTPClient<RoomDashboardDataDTO>(`${dashboardUrl}/santander/room`)

    async function getApi(filter: {roomId: string}){
        return await get({params: {...filter}})
    }

    return {
        data,
        loading,
        error,
        get: getApi
    }
}